/**
 * App theme constants - single source of truth for PWA/metadata/background colors.
 * Used by: layout.tsx (metadata), App.css (--app-bg), manifest.ts
 * Change these values to update theme-color and background app-wide.
 */
export const APP_BG_DARK = "#0B0D10";
export const APP_BG_LIGHT = "#F6F8FB";
